import jsPDF from 'jspdf';
import { renderDraftWatermark } from './invoiceComponents';
import { GenerateVendorInvoicePDFParams } from './types';
import { buildVendorInvoiceDocument } from './vendorInvoicePdfGenerator';
import { generateInvoiceFilename } from './invoiceCalculations';

/**
 * Applies a draft watermark to all pages of a PDF document
 */
export const applyDraftWatermark = (doc: jsPDF): void => {
  const totalPages = doc.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    renderDraftWatermark(doc);
  }
};

/**
 * Generate a vendor invoice PDF with a DRAFT watermark and download it
 * This builds on top of the basic vendor invoice (without NSP boxes) and adds a watermark
 */
export const generateDraftInvoicePDF = async (
  params: GenerateVendorInvoicePDFParams
): Promise<void> => {
  // Build the vendor invoice document (without NSP boxes)
  const doc = await buildVendorInvoiceDocument(params);

  // Apply draft watermark to all pages
  applyDraftWatermark(doc);

  // Generate filename and download
  const filename = generateInvoiceFilename(params.vendor.vendor_name, params.monthYear, 'Preview - ');
  doc.save(filename);
};
